import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dialog } from 'primereact/dialog';
import TOS from './TOS';

class TOSDialog extends Component {

  render() {

    const { open, toggle } = this.props;

    if (!open)
      return null;

    return (
      <Dialog 
        className="TOSDialog"
        visible={open}
        maximizable={true}
        onHide={() => toggle(false)}
        header="Terms of Service"
      >
        <TOS />
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => {
  return {
  };
}

const mapDispatchToProps = dispatch => {
  return {
  };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(TOSDialog);